export default __webpack_public_path__ + "static/media/ic_abkhazia.086d7ab8.svg";